import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Wrench, Cog, Palette, Box, Layers, Star, ExternalLink } from "lucide-react";

const items = [
  { icon: Box, title: "Prototypen", description: "Schnelle und kostengünstige Entwicklung von Prototypen für Ihre Produktideen." },
  { icon: Wrench, title: "Ersatzteile", description: "Individuelle Ersatzteile nach Maß, wenn Originalteile nicht mehr verfügbar sind." },
  { icon: Palette, title: "Kunst & Design", description: "Kreative Objekte, Skulpturen und Designstücke für Kunst und Dekoration." },
  { icon: Cog, title: "Funktionsteile", description: "Maßgefertigte technische Komponenten für spezifische Anforderungen." },
  { icon: Layers, title: "Modellbau", description: "Präzise Teile für Architekturmodelle, Tabletop und Miniaturwelten." },
  { icon: Star, title: "Individualisierung", description: "Personalisierte Produkte und kundenspezifische Sonderanfertigungen." },
];

const InspirationSection = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.05 });

  return (
    <div ref={ref}>
      <p className="text-[14px] text-[#6e6e73] mb-7">
        Auf der Suche nach Vorlagen?{" "}
        <a href="https://www.thingiverse.com" target="_blank" rel="noopener noreferrer"
          className="text-[#1d1d1f] hover:opacity-60 transition-opacity inline-flex items-center gap-1">
          Thingiverse <ExternalLink className="w-3 h-3" />
        </a>{" "}
        und{" "}
        <a href="https://www.printables.com" target="_blank" rel="noopener noreferrer"
          className="text-[#1d1d1f] hover:opacity-60 transition-opacity inline-flex items-center gap-1">
          Printables <ExternalLink className="w-3 h-3" />
        </a>{" "}
        bieten tausende kostenlose Modelle.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 12 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.4, delay: index * 0.06 }}
            className="bg-[#f5f5f7] rounded-2xl p-5 hover:bg-[#ebebeb] transition-colors group"
          >
            <div className="w-8 h-8 rounded-xl bg-white flex items-center justify-center mb-3 shadow-sm group-hover:bg-[#1d1d1f] transition-colors">
              <item.icon className="w-3.5 h-3.5 text-[#1d1d1f] group-hover:text-white transition-colors" />
            </div>
            <h3 className="font-semibold text-[#1d1d1f] text-[15px] mb-1">{item.title}</h3>
            <p className="text-[#6e6e73] text-[13px] leading-relaxed">{item.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default InspirationSection;
